import React, { useState, useEffect } from "react";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div className="logo-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_29fbdd7a-12d4-4367-bb60-da83a4682749/artifacts/hsju6cfd_DTIT-LOGO-Final-11825_page-0001.jpg" 
            alt="DoubleTap Innovations Logo" 
            className="logo"
          />
        </div>
        <nav className="navigation">
          <button onClick={() => scrollToSection("about")} className="nav-link">
            About
          </button>
          <button onClick={() => scrollToSection("vision")} className="nav-link">
            Vision
          </button>
          <button onClick={() => scrollToSection("why-doubletap")} className="nav-link">
            Why DoubleTap
          </button>
          <button onClick={() => scrollToSection("launching")} className="nav-link">
            Launching Soon
          </button>
          <button onClick={() => scrollToSection("contact")} className="nav-link nav-contact">
            Contact
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;